import { Pipe, PipeTransform } from '@angular/core';
import { Transaction } from '../../data/models';

/**
 * Formats a transaction's creation time into HH:mm format
 * @example {{ transaction | formatTime }} -> "14:30"
 */
@Pipe({
    name: 'formatTime',
    standalone: false
})
export class FormatTimePipe implements PipeTransform {
  transform(transaction : Transaction | null): string | undefined {
    return transaction?.createdAt?.toFormat('HH:mm');
  }
}
